import {
  VIKSU_HEALTH_CHECK_SUCCESS,
  FETCHING_FROM_VIKSU,
  GET_VIKSU_HEALTH_FAILED,
  GET_USER_INFO_REQUESTS,
  GET_USER_INFO_REQUESTS_FAILED,
  SAVE_USER_INFO_REQUEST_ID,
  SAVE_USER_INFO_REQEUST_ID_FAILED,
  DISMISS_SAVE_STATUS,
  serviceStatus,
  postUserInfoRequestStatus,
} from './actions';

export const initialState = {
  fetching: false,
  viksuStatus: serviceStatus.OFFLINE,
  lastSaveStatus: postUserInfoRequestStatus.UNKNOWN,
  dismissedStatus: false,
  userInfoRequests: [],
};

export const reducer = (state, action) => {
  let { type, payload } = action;
  switch (type) {
    case VIKSU_HEALTH_CHECK_SUCCESS:
      return {
        ...state,
        fetching: false,
        viksuStatus: serviceStatus.ONLINE,
      };
    case FETCHING_FROM_VIKSU:
      return {
        ...state,
        fetching: true,
      };
    case GET_VIKSU_HEALTH_FAILED:
      return {
        ...state,
        fetching: false,
        viksuStatus: serviceStatus.FAILED,
      };
    case GET_USER_INFO_REQUESTS:
      return {
        ...state,
        userInfoRequests: payload.userInfoRequests,
      };
    case GET_USER_INFO_REQUESTS_FAILED:
      return {
        ...state,
        fetching: false,
      };
    case SAVE_USER_INFO_REQUEST_ID:
      return {
        ...state,
        lastSaveStatus: payload.status,
        dismissedStatus: false,
      };
    case SAVE_USER_INFO_REQEUST_ID_FAILED:
      return {
        ...state,
        lastSaveStatus: postUserInfoRequestStatus.FAILED,
        dismissedStatus: false,
      };
    case DISMISS_SAVE_STATUS:
      return {
        ...state,
        dismissedStatus: true,
      };
    default:
      return state;
  }
};
